import { render, staticRenderFns } from "./ed-register-validate-phone.component.vue?vue&type=template&id=f4b79e2c&scoped=true&"
import script from "./ed-register-validate-phone.component.ts?vue&type=script&lang=ts&"
export * from "./ed-register-validate-phone.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-register-validate-phone.component.scss?vue&type=style&index=0&id=f4b79e2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b79e2c",
  null
  
)

export default component.exports